<template>
  <div id="app">
    <!-- <Loding v-if="isLoading"/> -->
    <transition :name="moveName" mode="out-in">
      <router-view class="main" :key="key"/>
    </transition>
  </div>
</template>

<script>
import Loding from '@/components/loding';
import { mapGetters } from 'vuex';
export default {
  components: {
    Loding
  },
  data() {
    return {
      moveName:"slide-list" 
    };
  },
  watch: {
    $route(to, from) {
      // 切换动画
      if (to.meta.index > from.meta.index) {
        this.moveName = "slide-detail";
      } else {
        this.moveName = "slide-list";
      }
    }
  },
  computed: {
    ...mapGetters([
      'isLoading'
    ]),
    key(){
	    return this.$route.path + Math.random();
	  }
  }
};
</script>
<style lang="scss">
// 进入  
@keyframes left-out{
    0%{transform: translateX(0);opacity: 1;}
    100%{transform: translateX(-100%);opacity: 0;}
}

@keyframes right-in{
    0%{transform: translateX(100%);opacity: 0;}
    100%{transform: translateX(0%);opacity: 1;}
}

// 返回 
@keyframes right-out{
    0%{transform: translateX(0%);opacity: 1;}
    100%{transform: translateX(100%);opacity: 0;}
}

@keyframes left-in{
    0%{transform: translateX(-100%);opacity: 0;}
    100%{transform: translateX(0%);opacity: 1;}
}

//  进来
.slide-detail-enter-active{
     animation: right-in .3s;
}

//  离开 
.slide-detail-leave-active{
    animation: left-out .3s;
}

//  进来
.slide-list-enter-active{
   animation: left-in .3s;
}

//  离开
.slide-list-leave-active{
    animation: right-out .3s;
}

#app {
  font-family: pingFangSC-Light, pingFangSC-Medium, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 20px !important;
  // overflow: hidden;
}
</style>
